import React, { FC, ReactNode, useEffect, useMemo } from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import parse from 'html-react-parser';

import { CookiesBar } from '@catawiki/layout';

import styles from './Layout.module.scss';

const Footer = dynamic(
  () => import('./LayoutFooter').then((mod) => mod.Footer),
  { ssr: false }
);

type AssetsData = {
  header: string;
  tags: {
    head: string;
    js: string;
    css: string;
  };
  footer: string;
  third_party: { gtm: string };
};

interface Props {
  data: AssetsData;
  children: ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
  showCookieBanner?: boolean;
}

export const Layout: FC<Props> = ({
  data,
  children,
  hideFooter,
  hideHeader,
  showCookieBanner,
}) => {
  const head = parse(data.tags.head + data.tags.css + data.third_party.gtm);

  useEffect(() => {
    document.body.classList.toggle('tw:header-offset', !hideHeader);
  }, [hideHeader]);

  const headerContent = useMemo(() => ({ __html: data.header }), [data.header]);
  const scriptsContent = useMemo(
    () => ({ __html: data.tags.js }),
    [data.tags.js]
  );

  /* eslint-disable react/no-danger */
  return (
    <>
      <Head>{head}</Head>
      {!hideHeader && (
        <div
          id="cw-header-container"
          className={styles.header}
          suppressHydrationWarning
          dangerouslySetInnerHTML={headerContent}
        />
      )}

      {/* Actual page content */}
      {children}
      {/* End actual page content */}
      {!hideFooter && <Footer imprintOnly />}
      {showCookieBanner && <CookiesBar />}
      <div
        id="cw-js-container"
        suppressHydrationWarning
        dangerouslySetInnerHTML={scriptsContent}
      />
    </>
  );
};
